<template>
  <li class="dialog-tree-row" v-bind:class="{'bg-highlight':hidden}">
    <div v-if="!loading">
      <div
        v-if="!editing && $store.claims.dialogs & 2 && $store.claims.phrases & 2"
        class="edit-icons"
      >
        <div class="icon-container" style="display:inline-block;float:rightS">
       
              
          <span v-if="!$store.searchState">
          <DropDown
            v-if="!dialog.new && !$store.dialogTreeSearch"
            :actions="dropdownActions"
            :tag="dialog.tags"
            :dropDownIcon="'add_circle_outline'"
          />
          </span>
          <span v-else>
            <DropDown
            v-if="isStart"
            :actions="dropdownActions"
            :tag="dialog.tags"
            :dropDownIcon="'add_circle_outline'"
          />
          </span>
           <span>
                <i
                  class="material-icons right  blue-text text-darken-1"
                  :class="this.taggedAsDoctor? this.doctorTagIsGlobal? 'yellow-text' : 'blue-text' : 'grey-text'"
                  v-if=" depth>=2"            
                  @click="toggleTagAsDoctor"      
                  style="margin-bottom: 5px; width: 24px"
                > <doctor-icon/></i>
                <i
                  class="material-icons right text-darken-1"
                  :class="this.taggedAsChat? this.chatbotTagIsGlobal? 'yellow-text' : 'blue-text' : 'grey-text'"
                  @click="toggleTagAsChat"
                  v-if="depth>=2"
                  style="margin-bottom: 5px; width: 24px"
                ><chatbot-icon/></i>
                
              </span>
          <i
            v-if="!isStart && !$store.searchState"
            class="material-icons right grey-text text-darken-1"
            @click="edit()"
          >edit</i>
          <i v-if="isStart"
            class="material-icons right grey-text text-darken-1"
            @click="downloadQR()"
          >
            <qr-code-icon />
          </i>
          <i
            v-if="isStart"
            class="material-icons right grey-text text-darken-1"
            @click="authorisation()"
            style="margin-bonttom: 5px"
          >accessibility</i>
          <i
            v-if="isStart"
            class="material-icons right grey-text text-darken-1"
            @click="handleRootDelete()"
            style="margin-bottom: 5px"
          >delete_sweep</i>

          <span v-if="!$store.searchState">
            <DropDown
              v-if="!isStart"
              :actions="settingsActions"
              :tag="dialog.tags"
              :dropDownIcon="'settings'"
            />

            <span v-if="!isStart">
               
             
              <span v-if="!$store.dialogTreeSearch">
                <i
                  v-if="isHidden()"
                  class="material-icons right grey-text text-darken-1"
                  @click="unhideDialog()"
                >visibility_off</i>
                <i
                  v-else
                  class="material-icons right grey-text text-darken-1"
                  @click="hideDialog()"
                >visibility</i>
              </span>
              
             
              <i v-if="dialog.type === 'answer'" style="float: right">
                <a
                  class="dropdown-trigg btn btn-floating btn-small btn-flat transparent"
                  :data-target="'dropdown' + dialog.id"
                >
                  <i class="material-icons right grey-text text-darken-1">
                    <p id="indicatorIcon" v-bind:style="{color:currentColor}">fiber_manual_record</p>
                  </i>
                </a>
                <ul :id="'dropdown' + dialog.id" class="dropdown-content">
                  <li @click="critcalLevelIndicator(0,dialog.id)">
                    <a>1</a>
                  </li>
                  <li @click="critcalLevelIndicator(1,dialog.id)">
                    <a>2</a>
                  </li>
                  <li @click="critcalLevelIndicator(2,dialog.id)">
                    <a>3</a>
                  </li>
                  <li @click="critcalLevelIndicator(3,dialog.id)">
                    <a>4</a>
                  </li>
                  <li @click="critcalLevelIndicator(4,dialog.id)">
                    <a>5</a>
                  </li>
                </ul>
              </i>
            </span>
          </span>
             
          <span v-else>
            <span v-if="!isStart && !$store.dialogTreeSearch">
              <i
                v-if="isHidden()"
                class="material-icons right grey-text text-darken-1"
                @click="unhideDialog()"
              ></i>
              <i
                v-else
                class="material-icons right grey-text text-darken-1"
                @click="hideDialog()"
              ></i>
            </span>
            <div class="switch right" >
              <label v-if="!isStart">
                <input
                  type="checkbox"
                    v-model="searchable"
                    @change ="saveSearchState($event)"
                />
                <span class="lever"></span>
              </label>
            </div>
          </span>
        </div>
      </div>
      <div
        :id="dialog.id"
        @click="toggle"
        v-if="!editing"
        class="text-preview"
        @dragstart="onDragStart"
        @drop="onDrop"
        @dragover="allowDrop"
        :draggable="!isStart"
        v-bind:class="{'grey-text text-darken-1': isStart}"
       >
        <span v-if="!isStart && displaySecondaryLanguage" class="number-badge">{{itemNumber}}</span>

        <img
          v-if="$store.dialogHasImage[dialog.id]"
          :src="$store.dialogHasImage[dialog.id]"
          v-on:click="upload($event,'fromimage')"
          :id="dialog.id"
          width="20"
          height="20"
        />
        <i
          v-else
          class="material-icons"
          v-bind:class="{'outline': open && !isStart, 'helen-green-text': !isStart}"
          v-on:click="upload($event,icon)"
          :id="dialog.id"
        >{{icon}}</i>

        <div class="preview-div" style="display:inline-grid">
          {{ primaryTranslation }}
          
          <div
            v-if="!isStart && displaySecondaryLanguage"
            dir="auto"
            class="secondary-language"
          >{{ secondaryTranslation }}</div>
      <span v-if="$store.dialogTreeSearch" style="font-size: 11px;color:#888">{{getStartNodeName}}</span>
        </div>

        <div
          v-if="$parent.dialog != undefined"
          v-for="(phrase, index) in currentPhraseList"
          :key="'phrase.id' + index"
          style="display: flex;flex-direction: column"
        >
          <div
            :id="phrase.id + '_' + index + $parent.dialog.id +'_' + 'span'"
            style="display:flex;justify-content: space-between;margin-top:10px"
          >
            <span
              style="white-space:pre-line;margin-left: 25px"
            >{{primaryPraragraphTranslation(phrase)}}</span>
            <i
              v-if = "!$store.searchState"
              @click="editParagraph(phrase,index)"
              class="material-icons prefix grey-text text-darken-1"
              style="margin-top: 5px"
            >edit</i>
          </div>
          <div
            :id="phrase.id + '_' + index + $parent.dialog.id +'_' + 'editbox'"
            style="margin-top:10px; display:none"
          >
            <textarea
              :ref="phrase.id + '_' + index + 'textarea'"
              class="preview-div-2"
              style="padding-left:28px;border:0px black !important;color:black"
              v-model="editingPhraseText"
            />
            <i
              @click="undoEditParagraph(phrase,index)"
              class="material-icons prefix grey-text text-darken-1"
              style="margin-top: 5px"
            >undo</i>
            <i
              @click="savePhrase(phrase,index)"
              class="material-icons prefix grey-text text-darken-1"
              style="margin-top: 5px"
            >save</i>
            <i
              @click="deletePhrase(phrase,index)"
              class="material-icons prefix grey-text text-darken-1"
              style="margin-top: 5px"
            >delete</i>
          </div>
        </div>
        <div v-if="!isStart &&searchable && $store.searchState" 
            class="text-preview-instances" 
            style ="background:#f0f9fb;"> 
          <div v-once>{{ getVisibleInstanceList() }}</div>
          <p class="preview-div-instances"> Visible for:&emsp;
            <span v-if="visibleInstanceList[0] =='This Instance' || visibleInstanceList[0] =='All Instances'">
              <b>{{ visibleInstanceList[0] }}</b>
            </span>
            <span v-else class="add-box" v-for="(value, index) in visibleInstanceList" :key="index" >
              {{ value }} 
            </span>
          </p>
            <i class="material-icons prefix right grey-text text-darken-1 " style ="margin-right: -2em;margin-top: 5px" @click.stop="instanceSetView()">edit</i>
        </div>																					  
        <div
          v-if="icon=='feedback' && $store.instructionAttachments[dialog.id]"
          :id="'instruction-images-'+dialog.id"
        >
          <div class="instruction-image-wrapper">
            <img
              v-for="(attach,index) in $store.instructionAttachments[dialog.id]"
              :key="index"
              :id="'img-' + index"
              v-if="attach.type == 'image'"
              :src="attach.data"
              @click="upload($event,'editInstImg',index);selectedInstructionAttachment(attach.id,index)"
              style="height:180px;width:200px;margin:10px"
            />
            <video
              v-for="(attach,index) in $store.instructionAttachments[dialog.id]"
              :key="index"
              :id="'vid-' + index"
              v-if="attach.type == 'video'"
              :src="attach.data"
              @click="upload($event,'editInstVid',index);selectedInstructionVidAttachment(attach.id,index)"
              style="height:180px;width:200px;margin:10px"
              controls
            ></video>
          </div>
          <div class="videoLink-wrapper">
            <div
              v-for="(attach,index) in $store.instructionAttachments[dialog.id]"
              v-if="attach.type == 'link'"
              style="margin-top:5px;padding:5px;"
            >
              <a :href="attach.data" target="_blank">{{attach.data}}</a>
              <i
                class="material-icons right grey-text text-darken-1"
                @click="deleteAttachmentLink(index)"
              >delete</i>
            </div>
          </div>
        </div>
      </div>
      <Modal
        v-if="showDeleteModal"
        :actions="deleteModalActions"
        :content="'Entire content(if any) of the dialog will be deleted. Are you sure you want to delete the dialog?'"
        :header="'Warning'"
      />
      <Modal
        v-if="showCopyModal"
        :content="'Current Dialog have '+ parentCount +' Parents'"
        :actions="copyDialogActions"
        :header="'Copy Actions'"
      />
      <div id="move_dialog">
        <Modal
          v-if="showMoveModal"
          :actions="moveDialogActions"
          :content="'Please Select the type of the Move Option you want..'"
          :header="'Move Actions'"
        />
      </div>
      <div v-if="editing" class="editingBox">
        <div class="toolbar">
          <span
            v-if="dialog.editor && dialog.created && this.$store.claims.users & 1"
            class="badge center tooltipped"
            data-badge-caption
            data-position="top"
            :data-tooltip="creationInfo"
          >{{editor}}</span>
          <!-- not for search tree roots -->
          <i
            v-if="$parent.dialog != undefined"
            @click="showDeleteModal = true"
            class="material-icons prefix grey-text text-darken-1 left"
          >delete</i>

          <label style="margin-right: 10px">
            <input
              type="checkbox"
              id="checkbox"
              class="filled-in"
              v-model="globally"
              ref="updateCheck"
            />
            <span v-if="!$store.dialogTreeSearch">Locally</span>
          </label>
          <label style="margin-right: 10px">
            <input
              type="checkbox"
              id="checkbox"
              class="filled-in"
              v-model="headingEnabled"
              ref="updateCheck"
            />
            <span v-if="!$store.dialogTreeSearch && editingParagraph">Heading</span>
          </label>
          <i @click="edit()" class="material-icons prefix grey-text text-darken-1">undo</i>
          <i
            v-if="dialog.type != 'instruction'"
            @click="save()"
            class="material-icons prefix grey-text text-darken-1"
          >save</i>
          <i
            v-else
            @click="saveInstruction()"
            class="material-icons prefix grey-text text-darken-1"
          >save</i>
        </div>

        <div v-if="dialog.type != 'instruction'" class="input-field">
          <img
            v-if="$store.dialogHasImage[dialog.id]"
            :src="$store.dialogHasImage[dialog.id]"
            class="prefix img-icon"
            width="20"
            height="20"
          />
          <i v-else class="material-icons prefix helen-green-text">{{icon}}</i>

          <input
            v-if="dialog.type != 'instruction'"
            id="paragraph"
            type="text"
            placeholder="Search"
            v-on:keyup="fetchPhraseSuggestion($event)"
            v-on:focus="fetchPhraseSuggestion($event)"
            v-model="editingPhraseText"
            required
          />
          <ul
            class="suggestion-list"
            id="suggestionList"
            style="max-height: 20em;overflow-y:auto;overflow-x: hidden;"
            @scroll="dilaogSuggestionScroll"
          >
            <li
              v-for="(suggestion,index) in searchSuggestion"
              :key="index"
              @click="setSuggestion(suggestion.text, suggestion.id)"
              style="display:flex;flex-direction:column"
            >
              <div>{{suggestion.text}}</div>
              <div style="font-size:11px;color:#888">{{suggestion.count}} translation(s) available</div>
            </li>
          </ul>
        </div>
        <div v-else class="instruction-input" style="display:flex">
          <i
            class="material-icons prefix helen-green-text"
            style="margin-top:25px;margin-right:5px"
          >{{icon}}</i>
          <div class="edit-flexed">
            <div class="input-field">
              <textarea
                id="paragraph"
                type="text"
                v-on:keyup="fetchPhraseSuggestion($event)"
                v-on:focus="fetchPhraseSuggestion($event)"
                v-model="editingPhraseText"
              ></textarea>
            </div>
            <ul
              class="suggestion-list"
              id="suggestionList"
              style="max-height: 20em;overflow-y:auto;overflow-x: hidden;"
              @scroll="dilaogSuggestionScroll"
            >
              <li
                v-for="(suggestion,index) in searchSuggestion"
                :key="index"
                @click="setSuggestion(suggestion.text, suggestion.id)"
                style="display:flex;flex-direction:column"
              >
                <div>{{suggestion.text}}</div>
                <div style="font-size:11px;color:#888">{{suggestion.count}} translation(s) available</div>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="dialog.type === 'answer'" class="answer-types">
          <p>Input type</p>
          <label v-for="(value, type) in inputTypes" :key="type">
            <input
              type="radio"
              :id="type"
              :value="value"
              :checked="selected===value"
              class="filled-in"
            />
            <span :for="type" @click="uncheck(value)">{{type}}</span>
          </label>
        </div>
      </div>
      <div v-if="tagEdit" class="editingBox">
        <div class="toolbar">
          <i class="material-icons prefix grey-text text-darken-1" @click="undoTag">undo</i>
          <i class="material-icons prefix grey-text text-darken-1" @click="addTag">save</i>
        </div>
        <div
          v-if="showChips"
          style="margin-top:5px"
          class="chip"
          v-for="(tag,index) in arrTag"
          :key="index"
        >
          {{tag}}
          <i
            class="material-icons tiny"
            style="margin-top: 10px"
            @click="deleteTag(index)"
          >close</i>
        </div>
        <input
          type="text"
          v-model="searchTag"
          placeholder="Press Enter Key to add Tag"
          v-on:keyup="tagSearch($event)"
          v-on:focus="tagSearch($event)"
          v-on:keyup.enter="inputTag($event)"
        />
        <ul class="suggestion-list">
          <li
            v-for="(suggestion,index) in searchArr"
            :key="index"
            style="display:flex;flex-direction:column"
            @click="selectSuggestion(suggestion)"
          >{{suggestion}}</li>
        </ul>
      </div> 
      <div v-if="categoryTagEdit" class="editingBox">
        <div class="toolbar">
          <i class="material-icons prefix grey-text text-darken-1" @click="undoCategoryTag">undo</i>
          <i class="material-icons prefix grey-text text-darken-1" @click="addCategoryTag">save</i>
        </div>
        <h3 class="tagList" v-if="showSavedTag">Saved Category Tags- </h3>
        <div
          v-if="showChips"
          style="margin-top:3px"
          class="chip savedCategory"
          v-for="(tag,index) in categoryArrTagList"
          :key="index"
        >
          {{tag}}
          <i
            class="material-icons tiny"
            style="margin-top: 10px"
            @click="deleteCategoryTagItem(index)"
          >close</i>
        </div>
        <input
          type="text"
          v-model="searchCategoryTag"
          placeholder="Press Enter Key to add category Tag"
          v-on:keyup="categoryTagSearch($event)"
          v-on:focus="categoryTagSearch($event)"
          v-on:keyup.enter="inputCategoryTag($event)"
        />
        <ul class="suggestion-list">
          <li
            v-for="(suggestion,index) in searchArr"
            :key="index"
            style="display:flex;flex-direction:column"
            @click="selectSuggestion(suggestion)"
          >{{suggestion}}</li>
        </ul>
      </div> 
      <ul v-show="open" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}"></ul>
      <ul v-show="open" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
        <treeItem
          v-for="(d, key) in dialogChild"
          :key="key"
          :itemNumber="isStart ? (key+1).toString() : itemNumber+'.'+(key+1)"
          :displaySecondaryLanguage="displaySecondaryLanguage"
          :secondaryLanguage="secondaryLanguage"
          :parentOpen="open"
          :dialog="d"
          :isSecond="isStart"
          :depth="depth+1"
        />
      </ul>
      <ul
        v-show="open && isEmpty"
        class="browser-default dialog-tree-list"
        v-bind:class="{start: isStart}"
      >
        <li class="grey-text text-darken-1 text-preview">Empty</li>
      </ul>
    </div>
    <Spinner v-if="loading" :size="'tiny'" />
  </li>	  
</template>

<style scoped>
.tagList{
  font-size: 12px;
  margin-top: 15px;
  margin-right:5px;
  display:inline;
}
.savedCategory{
  background-color: #bee2f5;
}
#indicatorIcon {
  margin: 0px;
  font-weight: bold;
}
.suggestion-list {
  margin: 0px;
}
.suggestion-list li {
  padding: 10px 5px;
  text-align: justify;
}
.suggestion-list li:hover {
  cursor: pointer;
  background: #efefef;
}
.start {
  padding-left: 0em;
}

ul.start > li > div > ul li {
  border-top: 1px solid #ccc;
  margin-bottom: -1px;
}
ul.start > li > div > ul li:hover {
  border-left: 2px solid dimgray;
  padding-left: 2px;
}
ul.start > li {
  padding: 5px;
  padding-right: 0px;
}
ul.start > li:nth-child(2n + 1) {
  background: #efefef;
  border-left: 2px solid #b7b7b7;
}
ul.start > li:nth-child(2n) {
  border-left: 2px solid #fff;
}
.img-icon {
  width: 20px !important;
}
.root-dialog:hover {
  color: rgba(255, 0, 0, 0.5) !important;
}
.center {
  position: relative;
  margin-left: -50%;
  left: -50%;
}
.secondary-language {
  color: #757575 !important;
}
.answer-types > label {
  margin-right: 1em;
}

.answer-types > p {
  color: darkgray;
}

.icon-spacer {
  width: 24px;
  height: 24px;
  margin-left: 15px;
}

.dialog-tree-list {
  list-style-type: none;
}

.text-preview {
  white-space: nowrap;
  padding-top: 0.4em;
  padding-bottom: 0.4em;
  padding-right: 72px;
}

.text-preview-instances {
  border: 1px solid lightgray;
  padding: 0em 3em 0em 1em;
  margin-right: 1px;
  margin-top: 2em;
}
.dialog-tree-row {
  cursor: pointer;
  padding-left: 0;
}

.material-icons {
  display: inline-flex;
  vertical-align: top;
  user-select: none;
}

.editingBox {
  border: 1px solid lightgray;
  padding: 0em 1em 0em 1em;
  margin-right: 1px;
  background: #fff;
}

.edit-icons {
  position: relative;
}
.icon-container {
  position: absolute;
  right: 0;
  top: 0.4em;
}
.toolbar {
  text-align: right;
  margin: 0em -1em 0em -1em;
  padding: 0.5em 1em 0.5em 1em;
  border-bottom: 1px solid lightgray;
}

.toolbar > i {
  margin-left: 0.5em;
}

.toolbar > i:hover {
  color: #6eb2bd !important;
}

.toolbar > .left {
  margin-left: 0;
}

.toolbar > .left:hover {
  color: #e57373 !important;
}
.number-badge {
  font-weight: 300;
  color: #fff;
  background-color: grey;
  border-radius: 2px;
  padding: 0 6px;
  vertical-align: top;
}
.preview-div {
  display: inline-block;
  white-space: normal;
  padding-right: 72px;
}
.preview-div-instances {
  display: inline-block;
  white-space: normal;
}
.instruction-image-wrapper {
  max-height: 212px;
  overflow-x: auto;
  background: white;
  display: flex;
  overflow-y: hidden;
}
.videoLink-wrapper {
  background: white;
  /* display: flex; */
  margin-top: 10px;
  /* overflow-x: auto;
  overflow-y: hidden; */
}
.bg-highlight {
  background: #fff59d !important;
}
.edit-flexed {
  flex-grow: 1;
  padding-bottom: 1em;
}
.drop {
  position: relative;
  display: inline-block;
}

.drop-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  z-index: 1;
}

.drop:hover .drop-content {
  display: block;
}

.instance-wrapper {
  white-space: nowrap;
  /* padding-top: 0.4em;
  padding-bottom: 0.4em; */
  overflow-x: auto;
  overflow-y: hidden;
  
  /* padding-right: 72px; */
  background: #f0f9fb;
}

.add-box {
  font-size: 11px;
  background-color: white;
  border-radius: 15px;
  border: 1px solid #dad3d3;
  padding: 2px 5px 2px 5px;
  margin: 2px;
}
</style>
<script>
import DropDown from "./DropDown";
import Modal from "./Modal";
import Spinner from "./Spinner";
import axios from "axios";	
import DoctorIcon from "../components/Icons/Doctor.vue"
import ChatbotIcon from "../components/Icons/Chatbot.vue"	  
import QrCodeIcon from '../components/Icons/QRCode.vue';

export default {
  name: "treeItem",
  props: {
    dialog: Object,
    parentOpen: Boolean,
    displaySecondaryLanguage: Boolean,
    secondaryLanguage: String,
    itemNumber: String,
    depth:Number
  },
  components: {
    DropDown,
    Modal,
    Spinner,
    DoctorIcon,
    ChatbotIcon,
    QrCodeIcon,	
  },
  data() {
    return {
      currDialog:{},
      allInstances:[],
      visibleInstanceList: [],										  
      searchable:true,
      parentCount: 0,
      disabled: true,
      rootNodeId: "",
      rootDialog: {},
      currentPhraseList: [],
      paragraphPhraseIds: [],
      isParagraph: false,
      instructionParagraphs: [],
      headingEnabled: false,
      dragNDrop: false,
      updateParent: false,
      copyDialog: {},
      showCopyModal: false,
      showMoveModal: false,
      globally: false,
      searchDialog: [],
      rootPath: [],
      parentDraggedDialog: "",
      isEmpty: false,
      dialogNextCount: [],
      getDialogList: true,
      parentId: "",
      dialogChild: [],
      dialogDataLoaded: true,
      open: false,
      phrase: {},
      nextDialogs: {},
      editing: false,
      editingDialog: null,
      editingPhraseText: "",
      editingParagraph: false,
      showDeleteModal: false,
      loadingDialogs: true,
      loadingPhrase: true,
      initalized: false,
      deletingRoot: false,
      hidden: false,
      cancelSource: null,
      searchSuggestion: [],
      suggestedPhraseID:"",
      currentSearchResult: {},
      currentColor: "blue",
      tagEdit: false,
      categoryTagEdit: false,
      tags: "",
      searchTag: "",
      searchCategoryTag: "",
      arrTag: [],
      categoryArrTagList: [],
      showChips: true,
      showSavedTag:false,
      searchArr: [],
      scrollAllowed: true,
      offsetPrev: 0,
      taggedAsDoctor: false,
      doctorTagIsGlobal: false,
      taggedAsChat: false,
      chatbotTagIsGlobal: false,
      inputTypes: {
        "Multi-select": "multiselect",
        Number: "input_number",
        Time: "input_time",
        "Rating-scale": "input_rating",
        Calendar: "calendar_input",
        Text: "text_input"
      },

      selected: "",

      dropdownActions: {
        Category: () => {
          this.addDialog("category");
        },
        Question: () => {
          this.addDialog("question");
        },
        Instruction: () => {
          this.addDialog("instruction");
        },
        Answer: () => {
          this.addDialog("answer");
        },
      },
      settingsActions: {
        // Authorize: () => {
        //   this.authorisation();
        // },
        AddTag: () => {
          this.editTag();
        },
        CategoryTag: () => {
          this.editCategoryTag();
        },
      },
      deleteModalActions: {
        Yes: () => {
          if (this.dialog.new) {
            this.removeDialog(this.dialog);
          } else {
            this.editing = false;
            this.deleteRootDialog();
          }
          this.showDeleteModal = false;
          this.deletingRoot = false;
        },
        No: () => {
          this.showDeleteModal = false;
        },
      },
      copyDialogActions: {
        locally: () => {
          this.loadingDialogs = true;
          this.copyDialogLocally(this.copyDialog);
          this.showCopyModal = false;
          this.dragNDrop = false;
        },
        globally: () => {
          this.loadingDialogs = true;
          this.copyDialogGlobally(this.copyDialog);
          this.showCopyModal = false;
          this.dragNDrop = false;
        },
        cancel: () => {
          this.showCopyModal = false;
        },
      },
      moveDialogActions: {
        locally: () => {
          this.loadingDialogs = true;
          this.moveDialogLocally(this.copyDialog);
          this.showMoveModal = false;
          this.dragNDrop = false;
        },
        globally: () => {
          this.loadingDialogs = true;
          this.moveDialogGlobally(this.copyDialog);
          this.showMoveModal = false;
          this.dragNDrop = false;
        },
        cancel: () => {
          this.showMoveModal = false;
        },
      },
    };
  },
  watch: {
    parentOpen: function (isOpen) {
      if (!isOpen) {
        this.open = false;
      } else if (!this.initialized) {
        if (this.dialog.next)
          this.getNext()
            .then(() => (this.loadingDialogs = false))
            .catch(() => (this.loadingDialogs = false));
        this.initialized = true;
      }
    },
    "dialog.phrase": function (id) {
      this.getPhraseByID(id);
    },
    "dialog.next": function (list) {
      this.nextDialogs = Object.keys(this.nextDialogs)
        .filter((d) => {
          return (
            this.dialog.next.indexOf(this.nextDialogs[d].id) > -1 ||
            this.nextDialogs[d].new
          );
        })
        .reduce((obj, key) => {
          obj[key] = this.nextDialogs[key];
          return obj;
        }, {});
      var newDialogs = [];
      if (this.dialog.next)
        this.dialog.next.forEach((id) => {
          if (!this.nextDialogs[id]) {
            newDialogs.push(id);
          }
        });
      newDialogs.forEach((element) => {
        this.getDialogByID(element);
      });
    },
  },
  mounted() {
    this.open = false;
    console.log('depth', this.depth);

    var elems = document.querySelectorAll(".dropdown-trigg");
    var instances = M.Dropdown.init(elems, {});
    this.changeColor(this.criticalLevel());
    var elems = document.querySelectorAll(".dropdown-trigg2");
    var instances = M.Dropdown.init(elems, {});

    var elems = document.querySelectorAll(".modal");
    var instances = M.Modal.init(elems, {});

   if(this.dialog.id == this.$store.lastUpdateId){
     this.$store.indexPath = []
     this.$store.lastUpdateId = ""
     this.$store.refreshStatus = false
   }
   if(this.$store.refreshStatus){
     if(this.$store.indexPath.includes(this.itemNumber)){
       this.toggle()
     }
   }
   //Initializing the searchable for each dialog
    if (this.dialog.tags) {
      if (this.dialog.tags.includes("search_off")) {
          this.searchable = false
        }
        else{
          this.searchable = true
        }
      }
      else{
          this.searchable = true
      }
    const tags = this.dialog.tags
    if (Array.isArray(tags)) {
        if (tags.includes("chatbot")) {
          this.taggedAsChat = true;
          this.chatbotTagIsGlobal = true;
        } else if (tags.includes("chatbot:"+this.getRootName())) {
          this.taggedAsChat = true;
          this.chatbotTagIsGlobal = false;
        } else {
          this.taggedAsChat = false;
          this.chatbotTagIsGlobal = false;
        }
      if(Array.isArray(tags)) {
        if (tags.includes("caregiver")) {
          this.taggedAsDoctor = true;
          this.doctorTagIsGlobal = true;
        } else if (tags.includes("caregiver:"+this.getRootName())) {
          this.taggedAsChat = true;
          this.doctorTagIsGlobal = false;
        } else {
          this.taggedAsDoctor = false;
          this.doctorTagIsGlobal = false;
        }
      } else {
        this.taggedAsChat = false;
        this.taggedAsDoctor = false;
      }
    }
      // on CloseInstanceView event sent from DialogInstanceView pop-up close, update the visibleInstaceList
      this.$root.$on('CloseInstanceView', data => {
        if(this.$store.currentDialogIdForInstanceView == this.dialog.id){
          this.updateDialogTags(this.dialog.id)
          .then(() => {
            this.getVisibleInstanceList()
          }).catch(() => this.toast("Could not update dialog tags"))
      }
    });
  },
  methods: {
    authorisation() {
      this.$store.showAuthorisationView = true;
      this.$store.currentDialogId = this.dialog.id;
    },
    downloadQR(){
      console.log('Download QR');
      this.$store.downloadQR(this.primaryTranslation);
    },
    toggleTagAsDoctor(){
      this.taggedAsDoctor = !this.taggedAsDoctor;
      const tags = this.dialog.tags;
      const rootName = this.getRootName();
      if(Array.isArray(tags)) {
        if (tags.includes("caregiver")) {
          const doctorIndex = tags.findIndex((i)=>i==='caregiver');
          this.dialog.tags.splice(doctorIndex,1);
        } else if (tags.includes("caregiver:"+rootName)){
          const doctorIndex = tags.findIndex((i)=>i==='caregiver:'+rootName);
          this.dialog.tags.splice(doctorIndex,1);
        } else {
          this.dialog.tags.push("caregiver:"+rootName);
          this.doctorTagIsGlobal = false;
        }
      } else {
        this.dialog.tags = [];
        this.dialog.tags.push("caregiver:"+rootName);
        this.doctorTagIsGlobal = false;
      }
      this.$store.putDialog(this.dialog);
    },
    toggleTagAsChat(){
      this.taggedAsChat = !this.taggedAsChat;
      const tags = this.dialog.tags;
      const rootName = this.getRootName();
      if(Array.isArray(tags)) {
        if (tags.includes("chatbot")) {
          const doctorIndex = tags.findIndex((i)=>i==='chatbot');
          this.dialog.tags.splice(doctorIndex,1);
        } else if (tags.includes("chatbot:"+rootName)){
          const doctorIndex = tags.findIndex((i)=>i==='chatbot:'+rootName);
          this.dialog.tags.splice(doctorIndex,1);
        } else {
          this.dialog.tags.push("chatbot:"+rootName);
          this.chatbotTagIsGlobal = false;
        }
      } else {
        this.dialog.tags = [];
        this.dialog.tags.push("chatbot:"+rootName);
        this.chatbotTagIsGlobal = false;
      }
      this.$store.putDialog(this.dialog);
    },
    async getNextDialog(id) {
      return new Promise((resolve, reject) => {
        this.dialogChild = [];
        var root = "";
        this.$http.get("/dialogs?parent=" + id +"&limit=500").then((response) => {
          if (response.data != null) {
            if (this.updateParent) {
              this.$parent.dialogChild = [];
              this.open = false;
            }
            response.data.forEach((element) => {
              if (element.type == "instruction") {
                if (element.attachments != null) {
                  this.updateInstructionAttachments(
                    element.attachments,
                    element.id
                  );
                }
              } else if (
                element.type == "answer" &&
                element.attachments != null
              ) {
                this.$set(
                  this.$store.dialogHasAttachment,
                  element.id,
                  element.attachments[0].id
                );
                this.updateDialogHasImage(
                  element.attachments[0].id,
                  element.id
                );
              } else if (
                element.type == "category" &&
                element.attachments != null
              ) {
                this.$set(
                  this.$store.dialogHasAttachment,
                  element.id,
                  element.attachments[0].id
                );
                this.updateDialogHasImage(
                  element.attachments[0].id,
                  element.id
                );
              } else if (
                element.type == "question" &&
                element.attachments != null
              ) {
                this.$set(
                  this.$store.dialogHasAttachment,
                  element.id,
                  element.attachments[0].id
                );
                this.updateDialogHasImage(
                  element.attachments[0].id,
                  element.id
                );
              }
              if (!this.updateParent) {
                this.dialogChild.push(element);
              } else {
                this.dialogDataLoaded = true;
                this.$parent.dialogChild.push(element);
              }
            });
          } else {
            this.dialogChild == [];
            this.isEmpty = true;
          }
          resolve(response);
        });
        (response) => {
          reject(response);
        };
      });
    },
    async getstartSearch(id) {
      return new Promise((resolve, reject) => {
        this.searchDialog = [];
        var root = "";
        this.$http.get("/dialogs?parent=" + id).then((response) => {
          if (response.data != null) {
            response.data.forEach((element) => {
              this.$store.currentDialogParentList.forEach((e) => {
                if (e.dialogId == id) {
                  root = e.root;
                }
              });
              var obj = {
                dialogId: "",
                parentId: "",
                root: "",
              };
              obj.dialogId = element.id;
              obj.parentId = id;
              obj.root = root;
              this.$store.currentDialogParentList.push(obj);
              this.searchDialog.push(element);
            });
          } else {
            this.searchDialog == [];
            this.isEmpty = true;
          }
          resolve(response);
        });
        (response) => {
          reject(response);
        };
      });
    },
    getDialogsChild(dialog) {
      var instance = "";
      var currentRoot = "";
      this.dialogChild = [];
      if (dialog != null || dialog != undefined) {
        if (dialog.tags != null) {
          dialog.tags.forEach((element) => {
            if (element.includes("start_")) {
              currentRoot = element;
              var myString = element.split("start_");
              instance = myString[1];
            }
          });
        }
      }
      return new Promise((resolve, reject) => {
        if (instance != "" && dialog.id != "") {
          this.$http
            .get("/dialogs?instance=" + instance + "&parent=" + dialog.id)
            .then(
              (r) => {
                if (r.data != null) {
                  r.data.forEach((element) => {
                    if (element.type == "instruction") {
                      if (element.attachments != null) {
                        this.updateInstructionAttachments(
                          element.attachments,
                          element.id
                        );
                      }
                    } else if (
                      element.type == "answer" &&
                      element.attachments != null
                    ) {
                      this.$set(
                        this.$store.dialogHasAttachment,
                        element.id,
                        element.attachments[0].id
                      );
                      this.updateDialogHasImage(
                        element.attachments[0].id,
                        element.id
                      );
                    } else if (
                      element.type == "category" &&
                      element.attachments != null
                    ) {
                      this.$set(
                        this.$store.dialogHasAttachment,
                        element.id,
                        element.attachments[0].id
                      );
                      this.updateDialogHasImage(
                        element.attachments[0].id,
                        element.id
                      );
                    }
                    this.dialogChild.push(element);
                  });
                }
              },
              (r) => {
                reject(r);
              }
            );
        }
      });
    },
    dilaogSuggestionScroll() {
      var searchQuery = this.editingPhraseText;
      var offsetVal = 10;
      var div = document.getElementById("suggestionList");
      var diff = div.scrollHeight - div.clientHeight - 1;
      if (this.searchSuggestion.length >= 30) {
        this.scrollAllowed = false;
      }
      if (div.scrollTop >= diff && this.scrollAllowed) {
        this.$http
          .get(
            "search/phraseSearch?text=" +
              searchQuery +
              "&lang_id=" +
              this.$store.preferredLanguage +
              "&offset=" +
              offsetVal,
            {
              headers: {
                type: "phrase",
              },
            }
          )
          .then((r) => {
            if (r) {
              var vm = this;
              var phrases = [];
              r.data.forEach(function (phrase) {
                phrase.translations.forEach(function (translation) {
                  if (translation.language == vm.$store.preferredLanguage) {
                    var obj = {
                      text: translation.text,
                      count: phrase.translations.length,
                      id: phrase.id
                    };
                    phrases.push(obj);
                    vm.searchSuggestion.push(obj);
                    vm.currentSearchResult[phrase.id] = phrase;
                  }
                });
              });
            }
            (err) => {};
            this.offsetPrev += 10;
          });
      }
    },
    selectedInstructionAttachment(attachmentId, attachmentIndex) {
      this.$store.instructionImgselected = true;
      this.$store.instructionImg = [];
      var imgProp = {
        id: "",
        index: "",
      };
      imgProp.id = attachmentId;
      imgProp.index = attachmentIndex;

      this.$store.instructionImg.push(imgProp);
    },
    selectedInstructionVidAttachment(attachIdVid, attachIndexVid) {
      this.$store.instructionVidselected = true;
      this.$store.instructionVid = [];

      var vidProp = {
        id: "",
        index: "",
      };
      vidProp.id = attachIdVid;
      vidProp.index = attachIndexVid;

      this.$store.instructionVid.push(vidProp);
    },
    uncheck: function (val) {
      if (val === this.selected) {
        this.selected = false;
        var index = this.editingDialog.tags.indexOf(val);
        this.editingDialog.tags.splice(index, 1);
      } else {
        var statusTagUpdt = true;
        this.selected = val;
        const inputType = Object.values(this.inputTypes);
        inputType.forEach((element) => {
          if (this.editingDialog.tags.indexOf(element) >= 0) {
            var indEdit = this.editingDialog.tags.indexOf(element);
            this.editingDialog.tags[indEdit] = val;
            statusTagUpdt = false;
          }
        });
        if (statusTagUpdt) {
          this.editingDialog.tags.unshift(val);
        }
      }
    },
    changeColor(val) {
      if (val == 1) {
        this.currentColor = "green";
      }
      if (val == 2) {
        this.currentColor = "darkseagreen";
      }
      if (val == 3) {
        this.currentColor = "orange";
      }
      if (val == 4) {
        this.currentColor = "orangered";
      }
      if (val == 5) {
        this.currentColor = "red";
      }
      if (val == -1) {
        this.currentColor = " ";
      }
    },
    criticalLevel() {
      var level = -1;
      if (this.dialog.tags) {
        this.dialog.tags.forEach((element, i) => {
          if (element.includes("critical:")) {
            level = element.charAt(element.length - 1);
          }
        });
      }
      return level == -1 ? level : parseInt(level) + 1;
    },
    critcalLevelIndicator(level, id) {
      var updated_dialog = {};
      var critical_level = "";
      var status = false;

      if (this.dialog.tags === null || this.dialog.tags.length == 0) {
        this.dialog.tags = [];
        critical_level = "critical:" + level;

        this.dialog.tags.push(critical_level);

        updated_dialog = Object.assign({}, this.dialog);
      } else {
        var index = -1;
        critical_level = "critical:" + level;

        this.dialog.tags.forEach((element, i) => {
          if (element.includes("critical:")) {
            index = i;
          }
        });
        if (index >= 0) {
          this.dialog.tags.splice(index, 1, critical_level);
        } else {
          this.dialog.tags.push(critical_level);
        }
        updated_dialog = Object.assign({}, this.dialog);
      }
      this.$store
        .putDialog(updated_dialog)
        .then((r) => {
          this.changeColor(this.criticalLevel());
        })
        .catch(() => this.toast("Could not update dialog"));
    },
    setSuggestion(suggestion, id) {
      this.editingPhraseText = suggestion;
      this.suggestedPhraseID = id;
      this.searchSuggestion = [];
    },
    fetchPhraseSuggestion(event) {
      this.offsetPrev = 0;
      this.scrollAllowed = true;
      var searchQuery = this.editingPhraseText;
      if (this.cancelSource) {
        this.cancelSource.cancel("previous search request cancelled");
      }
      this.cancelSource = axios.CancelToken.source();
      if (searchQuery.length == 0) {
        this.searchSuggestion = [];
        return;
      }
      this.$http
        .get(
          "search/phraseSearch?text=" +
            searchQuery +
            "&lang_id=" +
            this.$store.preferredLanguage,
          {
            cancelToken: this.cancelSource.token,
            headers: {
              type: "phrase",
            },
          }
        )
        .then(
          (r) => {
            if (r) {
              this.cancelSource = null;
              var vm = this;
              var phrases = [];
              r.data.forEach(function (phrase) {
                phrase.translations.forEach(function (translation) {
                  if (translation.language == vm.$store.preferredLanguage) {
                    var obj = {
                      text: translation.text,
                      count: phrase.translations.length,
                      id: phrase.id
                    };
                    phrases.push(obj);
                    vm.currentSearchResult[phrase.id] = phrase;
                  }
                });
              });
              this.searchSuggestion = phrases;
            }
            if (this.searchSuggestion.length < 10) {
              this.scrollAllowed = false;
            }
          },
          (err) => {}
        );
    },
    hideDialog() {
      this.loadingDialogs = true;
      var rootName = this.getRootName();
      var parentId = this.$parent.dialog.id;
      var tag = "start_" + rootName + ":" + parentId + ":" + "hidden";
      this.$http.post("/dialogs/" + this.dialog.id + "/hide/" + tag).then((r) => {
        this.loadingDialogs = false;
        if (r.data.status) {
          this.saveReminder();
          this.dialog.tags = this.dialog.tags ? this.dialog.tags : [];
          this.dialog.tags.push(tag);
          this.hidden = true;
        } else {
          M.toast({ html: r.data.error_message, classes: "red" });
        }
      });
    },
    unhideDialog() {
      if (this.$parent.hidden) return;
      this.loadingDialogs = true;
      var rootName = this.getRootName();
      var parentId = this.$parent.dialog.id;
      var tag = "start_" + rootName + ":" + parentId + ":" + "hidden";
      this.$http.post("/dialogs/" + this.dialog.id + "/unhide/" + tag).then((r) => {
        this.loadingDialogs = false;
        if (r.data.status) {
            this.saveReminder();
            var index = this.dialog.tags.indexOf(tag);
            if(index >= 0) this.dialog.tags.splice(index, 1);
            this.hidden = false;
        } else {
          M.toast({ html: r.data.error_message, classes: "red" });
        }
      });
    },
    /**
     * Check if the dialog or its parent is hidden
     */
    isHidden() {
      var rootName = this.getRootName();
      var parentId = this.$parent.dialog.id;
      if (this.$parent.hidden) {
        this.hidden = true;
        return true;
      }
      if(this.dialog.tags && this.dialog.tags.indexOf("start_" + rootName + ":" + parentId + ":" + "hidden") >= 0){
        this.hidden = true;
        return true;
      }
      this.hidden = false;
      return false;
    },
    saveReminder(){
      var rID = this.getRootId();
      var rName = this.getRootName();
      this.$set(this.$store.unsavedChangesInRoot, rName, rID);
    },
    getRootName(){
      var rootName = "";
      var dialog = this;
      if (this.dialog.parent == null) {
        rootName = this.dialog.phrase;
        return rootName;
      }
      while (true) {
        var parent = dialog.$parent;
        dialog = parent;
        rootName = dialog.dialog.phrase;
        if (parent.dialog.tags && parent.dialog.tags.indexOf("start") >= 0)
          break;
      }
      return rootName;
    },
    getRootId(){
      var rootId = "";
      var dialog = this;
      if (this.dialog.parent == null) {
        rootId = this.dialog.id;
        return rootId;
      }
      while (true) {
        var parent = dialog.$parent;
        dialog = parent;
        rootId = dialog.dialog.id;
        if (parent.dialog.tags && parent.dialog.tags.indexOf("start") >= 0)
          break;
      }
      return rootId;
    },
    deleteRootDialog(vm) {
      var d = vm ? vm : this;
      d.$parent.$emit("delete:dialog", d.dialog);
    },
    upload(el, icon, instAttachIndex) {
      this.$store.currentDialogRef = this;
      this.$store.currentDialog = this.dialog;
      if (icon == "chat" || icon == "fromimage") {
        this.$store.uploadingInstructionImage = false;
        this.$store.currentDialogId = this.dialog.id;
        if (icon == "fromimage") {
          this.$store.changeDeleteImage = true;
          this.$store.uploadDialogImgSrc = this.$store.dialogHasImage[
            this.$store.currentDialogId
          ];
          this.$store.imageChosen = true;
        } else {
          this.$store.changeDeleteImage = false;
          this.$store.uploadDialogImgSrc = "";
        }
        this.$store.answerImageUploadDialog = true;
        this.$store.showUploadImageDialog = true;
        this.$store.imageChosen = true;
        this.$store.videoChosen = false;
        this.$store.linkChosen = false;
      }
      if (icon == "folder") {
        this.$store.uploadingInstructionImage = false;
        this.$store.currentDialogId = this.dialog.id;
        this.$store.changeDeleteImage = false;
        this.$store.uploadDialogImgSrc = "";
        this.$store.answerImageUploadDialog = true;
        this.$store.showUploadImageDialog = true;
        this.$store.imageChosen = true;
        this.$store.videoChosen = false;
        this.$store.linkChosen = false;
      }
      if (icon == "feedback") {
        this.$store.uploadingInstructionImage = true;
        this.$store.currentDialogId = this.dialog.id;
        this.$store.showUploadImageDialog = true;
        this.$store.editingInstImg = false;
        this.$store.changeDeleteImage = false;
        this.$store.uploadDialogImgSrc = "";
        this.$store.imageChosen = true;
        this.$store.videoChosen = true;
        this.$store.linkChosen = true;
      }
      if (icon == "help") {
        this.$store.uploadingInstructionImage = false;
        this.$store.currentDialogId = this.dialog.id;
        if (icon == "fromimage") {
          this.$store.changeDeleteImage = true;
          this.$store.uploadDialogImgSrc = this.$store.dialogHasImage[
            this.$store.currentDialogId
          ];
          this.$store.imageChosen = true;
        } else {
          this.$store.changeDeleteImage = false;
          this.$store.uploadDialogImgSrc = "";
        }
        this.$store.answerImageUploadDialog = true;
        this.$store.showUploadImageDialog = true;
        this.$store.imageChosen = true;
        this.$store.videoChosen = false;
        this.$store.linkChosen = false;
      }
      if (icon == "editInstImg") {
        this.$store.changeDeleteImage = true;
        this.$store.uploadingInstructionImage = true;
        this.$store.currentDialogId = this.dialog.id;
        var attachArr = this.$store.instructionAttachments[this.dialog.id];
        this.$store.uploadDialogImgSrc = attachArr[instAttachIndex].data;
        this.$store.editingInstImgIndex = instAttachIndex;
        this.$store.imageChosen = true;
        this.$store.videoChosen = false;
        this.$store.editingInstImg = true;
        this.$store.showUploadImageDialog = true;
        this.$store.linkChosen = false;
      }
      if (icon == "editInstVid") {
        this.$store.changeDeleteVideo = true;
        this.$store.currentDialogId = this.dialog.id;
        var attachArr = this.$store.instructionAttachments[this.dialog.id];
        this.$store.uploadDialogVidSrc = attachArr[instAttachIndex].data;
        this.$store.editingInstVidIndex = instAttachIndex;
        this.$store.videoChosen = true;
        this.$store.imageChosen = false;
        this.$store.editingInstVid = true;
        this.$store.showUploadImageDialog = true;
        this.$store.linkChosen = false;
      }
    },
    deleteAttachmentLink(index) {
      var attachArray = this.$store.instructionAttachments[this.dialog.id];
      var attach = attachArray[index];
      var vm = this;
      this.$http
        .delete("/dialogs/" + this.dialog.id + "/attachmentsText/" + attach.id)
        .then(function (r) {
          attachArray.splice(index, 1);
          vm.$set(vm.$store.instructionAttachments, vm.dialog.id, attachArray);
        });
    },
    onDragStart(ev) {
      if(!(this.$store.claims.dialogs & 2 && this.$store.claims.phrases & 2)){
        return
      }
      this.$store.draggedDialog = this;
      ev.dataTransfer.setData("text/plain", JSON.stringify(this.dialog));
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    /**
     * Fetch dialog based on ID
     * @param {string} id ID of dialog to fetch
     * if a current dialog is root dialog then its order is updated(re-order dialog)
     */
    updateDialogOrder(dialogId){
      this.$http.get("/dialogs/" + dialogId).then((response) => {
        this.dialog.order = response.data.order
      })
    },
    /**
     *Updating the dialog tags in the treeitem view after updating tags in DialogInstanceView
     */
    updateDialogTags(dialogId){
      return new Promise((resolve, reject) => {
        this.$http.get("/dialogs/" + dialogId)
          .then((response) => {
              this.dialog.tags = response.data.tags
              resolve(response.data);
            },
            (response) => {
              reject(response);
            });
      });
    },
    moveDialogLocally(dialog) {
      var parent = "";
      var vm = this;
      const draggedId = dialog.id;
      const droppedId = this.dialog.id;
      const parentId = this.$store.draggedDialog.$parent.dialog.id;
      var next = this.$store.draggedDialog.$parent.dialogChild;
      var indexDragged = 0;
      next.forEach((element) => {
        if (element.id == draggedId) {
          indexDragged = next.indexOf(element);
        }
      });
      this.$http
        .put("/dialogs/" + draggedId + "/move", {
          destination_dialogs: this.rootPath,
          is_locally: true,
          index: -1,
          dialog_parent: this.parentDraggedDialog,
          root_dialog: this.rootNodeId,
        })
        .then((r) => {
          vm.$store.lastUpdateId = r.data.dialog_id;
          vm.refreshDialogs(r.data.dialog_parent_old, r.data.dialog_parent_new);
          next.forEach((element) => {
            if (element.id === draggedId) {
              next.splice(indexDragged, 1);
            }
          });
        });
      return;
    },
    moveDialogGlobally(dialog) {
      var parent = "";
      var vm = this;
      const draggedId = dialog.id;
      const droppedId = this.dialog.id;
      const parentId = this.$store.draggedDialog.$parent.dialog.id;
      var next = this.$store.draggedDialog.$parent.dialogChild;
      var indexDragged = 0;
      next.forEach((element) => {
        if (element.id == draggedId) {
          indexDragged = next.indexOf(element);
        }
      });
      this.$http
        .put("/dialogs/" + draggedId + "/move", {
          destination_dialogs: this.rootPath,
          is_locally: false,
          index: -1,
          dialog_parent: this.parentDraggedDialog,
          root_dialog: this.rootNodeId,
        })
        .then((r) => {
          if(dialog.tags && dialog.tags.indexOf("start_" + rootName + ":" + parentId + ":" + "hidden") >= 0){
            console.log("it is hiiden");
            var tag = "start_" + rootName + ":" + parentId + ":" + "hidden";
            this.$http.post("/dialogs/" + dialog.id + "/unhide/" + tag).then((r) => {
            });
          }
          vm.$store.lastUpdateId = r.data.dialog_id;
          vm.refreshDialogs(r.data.dialog_parent_old, r.data.dialog_parent_new);
          next.forEach((element) => {
            if (element.id === draggedId) {
              next.splice(indexDragged, 1);
            }
          });
        });
      return;
    },
    copyDialogLocally(dialog) {
      var vm = this;
      var parent = "";
      const draggedId = dialog.id;
      const droppedId = this.dialog.id;

      this.$http
        .put("/dialogs/" + draggedId + "/copy", {
          destination_dialogs: this.rootPath,
          is_locally: true,
          index: -1,
          dialog_parent: this.parentDraggedDialog,
          root_dialog: this.rootNodeId,
        })
        .then((r) => {
          this.loadingDialogs = true;
          this.updateParent = true;
          this.$store.lastUpdateId = r.data.dialog_id;
          this.refreshDialogs(
            r.data.dialog_parent_old,
            r.data.dialog_parent_new
          );

          this.loadingDialogs = false;
          this.dragNDrop = false;
        });
    },
    copyDialogGlobally(dialog) {
      var vm = this;
      var parent = "";
      const draggedId = dialog.id;
      const droppedId = this.dialog.id;

      this.$http
        .put("/dialogs/" + draggedId + "/copy", {
          destination_dialogs: this.rootPath,
          is_locally: false,
          index: -1,
          dialog_parent: this.parentDraggedDialog,
          root_dialog: this.rootNodeId,
        })
        .then((r) => {
          this.loadingDialogs = true;
          this.updateParent = false;

          this.$store.lastUpdateId = r.data.dialog_id;
          this.refreshDialogs(
            r.data.dialog_parent_old,
            r.data.dialog_parent_new
          );
          this.loadingDialogs = false;
          this.dragNDrop = false;
        });
    },
    refreshDialogs(oldId, newId) {
      if(this.dialog.tags != null){
        if(this.dialog.tags.includes("start")){
          this.updateDialogOrder(this.dialog.id)
        }
      }
      var path = [this.dialog.id];
      var dialog = this;
      var dialogId = oldId;
      while (true) {
        var parent = dialog.$parent;
        this.$store.indexPath.push(dialog.itemNumber);
        if (parent.dialog != undefined) {
          if (parent.dialog.id == oldId) {
            
            this.$store.refreshStatus = true  
            parent.loadingDialogs = true;
            this.getNextDialog(newId);
            parent.loadingDialogs = false;
            parent.dialogChild = this.dialogChild;
            break;
          }else if(dialog.dialog.id == oldId){
            dialog.loadingDialogs = true;

            this.$store.refreshStatus = true
            this.getNextDialog(newId);
            dialog.loadingDialogs = false;
            dialog.dialogChild = this.dialogChild;

            break;
          }else {
            dialog = parent;
          }
        } else {
          if (dialog.dialog.id == oldId) {
            dialog.loadingDialogs = true;

            this.$store.refreshStatus = true
            this.getNextDialog(newId);
            dialog.loadingDialogs = false;
            dialog.dialogChild = this.dialogChild;

            break;
          } else {
            dialog = parent;
          }
        }
      }
      path = path.reverse();
      return path;
    },
    getRootNodeId() {
      var rootId = "";
      var dialog = this;
      if (this.dialog.parent == null) {
        rootId = this.dialog.id;
        this.rootDialog = this.dialog;
        return rootId;
      }
      while (true) {
        var parent = dialog.$parent;
        dialog = parent;
        rootId = dialog.dialog.id;
        this.rootDialog = dialog.dialog;
        if (parent.dialog.tags && parent.dialog.tags.indexOf("start") >= 0)
          break;
      }
      return rootId;
    },
    getPathToNode() {
      var nodeWithMultipleParents = "";
      var parentOfNodeWithMultipleParents = "";
      var path = [this.dialog.id];
      var dialog = this;
      if (this.dialog.parent == null) {
        return path;
      }
      while (true) {
        if (dialog.dialog == undefined) {
          break;
        }
        if (dialog.dialog.parent.length > 2) {
          nodeWithMultipleParents = dialog.dialog.id;
        }
        var parent = dialog.$parent;
        path.push(parent.dialog.id);
        dialog = parent;
        if (parent.dialog.tags && parent.dialog.tags.indexOf("start") >= 0)
          break;
      }
      path = path.reverse();
      if (nodeWithMultipleParents) {
        var index = path.indexOf(nodeWithMultipleParents);
        index = index - 1;
        parentOfNodeWithMultipleParents = path[index];
        var i = path.indexOf(parentOfNodeWithMultipleParents);
        path = path.slice(i);
      } else {
        if (!this.dragNDrop) {
          path.pop();
        }
      }
      return path;
    },
    /**
     * Handle drop of dialogs
     * @param {Object} ev Incomming event
     */
    async onDrop(ev) {
      if(!(this.$store.claims.dialogs & 2 && this.$store.claims.phrases & 2)){
        return;
      }
      if (this.$store.dialogTreeSearch) return;
      this.dragNDrop = true;
      this.rootNodeId = this.getRootNodeId();
      var path = this.getPathToNode();
      this.saveReminder();
      var parentOfDraggedDialog = this.$store.draggedDialog.$parent.dialog.id;
      this.parentDraggedDialog = parentOfDraggedDialog;
      this.rootPath = path;
      if (!this.$store.reorder) {
        try {
          var dialog = JSON.parse(ev.dataTransfer.getData("text"));
          this.copyDialog = Object.assign({}, dialog);
        } catch {
          return;
        }
        if (this.dialog.id === dialog.id || this.dialog.new || dialog.new)
          return;
        if (this.$store.moveDialog) {
          if (this.dialog.parent != null && this.dialog.parent.length > 2) {
            this.parentCount = this.dialog.parent.length - 1;
            this.showMoveModal = true;
          } else {
            this.loadingDialogs = true;
            this.moveDialogGlobally(this.copyDialog);
            this.dragNDrop = false;
            return;
          }
          return;
        }
        if (this.dialogChild && this.dialogChild.indexOf(dialog.id) < 0) {
          if (this.dialog.parent != null && this.dialog.parent.length > 2) {
            this.parentCount = this.dialog.parent.length - 1;
            this.showCopyModal = true;
          } else {
            this.loadingDialogs = true;
            this.copyDialogGlobally(this.copyDialog);
            this.dragNDrop = false;
            return;
          }
          return;
        } else {
          return;
        }
        this.open = true;
      } else {
        var dialog = JSON.parse(ev.dataTransfer.getData("text"));
        const draggedId = dialog.id;
        const droppedId = this.dialog.id;
        if (this.$parent.dialog.order.indexOf(draggedId) < 0)
          return;
        const parentId = this.$parent.dialog.id;
        var newNext = JSON.parse(JSON.stringify(this.$parent.dialogChild));

        var indexDragged = 0;
        var indexDropped = 0;
        var next = this.$parent.dialogChild;
        next.forEach((element) => {
          if (element.id == draggedId) {
            indexDragged = next.indexOf(element);
          } else if (element.id == droppedId) {
            indexDropped = next.indexOf(element);
          }
        });

        if (indexDropped < indexDragged) {
          next.forEach((element) => {
            if (element.id == draggedId) {
              next.splice(indexDropped, 0, element);
              next.splice(indexDragged + 1, 1);
            }
          });
        } else if (indexDropped > indexDragged) {
          newNext.forEach((element) => {
            if (element.id == draggedId) {
              next.splice(indexDropped + 1, 0, element);
              next.splice(indexDragged, 1);
            }
          });
        }
        this.$http.put("/dialogs/" + draggedId + "/reorder", {
          index: indexDropped,
          dialog_parent: this.parentDraggedDialog,
        });
      }
    },
    /**
     * Toggle folder state
     */
    toggle() {
      this.open = !this.open;
      if (this.open && this.dialogDataLoaded && !this.$store.dialogTreeSearch) {
        this.loadingDialogs = true;
        this.dialogDataLoaded = false;
        this.updateParent = false;
        this.getNextDialog(this.dialog.id);
        this.loadingDialogs = false;
      } else if (
        this.open &&
        this.dialogDataLoaded &&
        this.$store.dialogTreeSearch
      ) {
        this.loadingDialogs = true;
        this.dialogDataLoaded = false;
        this.open = true;
        this.getNextDialog(this.dialog.id);
        this.loadingDialogs = false;
      }
    },
    /**
     * Fetch dialog based on ID
     * @param {string} id ID of dialog to fetch
     */
    getDialogByID(id) {
      this.$set(this.$store.dialogRef, this.dialog.id, this);
      return new Promise((resolve, reject) => {
        this.$http.get("dialogs/" + id).then(
          (response) => {
            if (!response.data.next) response.data.next = [];
            this.$set(this.nextDialogs, id, response.data);
            if (
              response.data.type == "answer" &&
              response.data.attachments &&
              response.data.attachments.length > 0
            ) {
              this.$set(
                this.$store.dialogHasAttachment,
                response.data.id,
                response.data.attachments[0].id
              );
              this.updateDialogHasImage(
                response.data.attachments[0].id,
                response.data.id
              );
            }
            if (
              response.data.type == "category" &&
              response.data.attachments &&
              response.data.attachments.length > 0
            ) {
              this.$set(
                this.$store.dialogHasAttachment,
                response.data.id,
                response.data.attachments[0].id
              );
              this.updateDialogHasImage(
                response.data.attachments[0].id,
                response.data.id
              );
            }
            if (
              response.data.type == "instruction" &&
              response.data.attachments &&
              response.data.attachments.length > 0
            ) {
              this.updateInstructionAttachments(
                response.data.attachments,
                response.data.id
              );
            }
            if (response.data.next && response.data.next.length > 0) {
              response.data.next.forEach((element) => {
                this.$set(this.$store.dialogParent, element, response.data.id);
              });
            }
            this.loadingDialogs = false;
            resolve();
          },
          (response) => {
            reject();
          }
        );
      });
    },

    updateDialogHasImage(imageId, answerId) {
      var vm = this;
      this.$http
        .get("/dialogs/" + answerId + "/attachments/" + imageId, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let image = btoa(
            new Uint8Array(response.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
          var dialogImg = `data:${response.headers[
            "content-type"
          ].toLowerCase()};base64,${image}`;
          vm.$set(vm.$store.dialogHasImage, answerId, dialogImg);
        })
        .catch(function () {
          vm.$delete(vm.$store.dialogHasImage, answerId);
          vm.$delete(vm.$store.dialogHasAttachment, answerId);
        });
    },
    async updateInstructionAttachments(attachments, instructionId) {
      var vm = this;
      vm.$store.instructionAttachments = vm.$store.instructionAttachments
        ? vm.$store.instructionAttachments
        : {};
      vm.$set(vm.$store.instructionAttachments, instructionId, []);
      for (let i = 0; i < attachments.length; i++) {
        if (attachments[i].contentType.indexOf("image") >= 0) {
          await this.getImageAttachment(attachments[i].id, i, instructionId);
        }
        if (
          attachments[i].contentType.indexOf("video") >= 0 ||
          attachments[i].contentType.indexOf("application/octet-stream") >= 0
        ) {
          await this.getVideoAttachment(attachments[i].id, i, instructionId);
        }
        if (attachments[i].contentType.indexOf("text") >= 0) {
          var obj = {
            type: "link",
            data: attachments[i].filename,
            id: attachments[i].id,
          };
          var vm = this;
          vm.$store.instructionAttachments = vm.$store.instructionAttachments
            ? vm.$store.instructionAttachments
            : {};
          var instAttachments = vm.$store.instructionAttachments[instructionId]
            ? vm.$store.instructionAttachments[instructionId]
            : [];
          instAttachments.push(obj);
          vm.$set(
            vm.$store.instructionAttachments,
            instructionId,
            instAttachments
          );
        }
      }
    },
    getImageAttachment(id, i, instructionId) {
      var vm = this;
      return new Promise((resolve, reject) => {
        this.$http
          .get("dialogs/" + instructionId + "/attachments/" + id, {
            responseType: "arraybuffer",
          })
          .then(
            (response) => {
              let image = btoa(
                new Uint8Array(response.data).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              );
              var instImg = `data:${response.headers[
                "content-type"
              ].toLowerCase()};base64,${image}`;

              var obj = {
                type: "image",
                data: instImg,
                id: id,
              };

              vm.$store.instructionAttachments = vm.$store
                .instructionAttachments
                ? vm.$store.instructionAttachments
                : {};
              var instAttachments = vm.$store.instructionAttachments[
                instructionId
              ]
                ? vm.$store.instructionAttachments[instructionId]
                : [];
              instAttachments.push(obj);
              vm.$set(
                vm.$store.instructionAttachments,
                instructionId,
                instAttachments
              );

              var imageArray = vm.$store.instructionImages[instructionId]
                ? vm.$store.instructionImages[instructionId]
                : [];
              var imageIdArray = vm.$store.instructionImagesId[instructionId]
                ? vm.$store.instructionImagesId[instructionId]
                : [];
              if (i == 0) {
                imageArray = [];
                imageIdArray = [];
              }
              imageArray.splice(i, 0, instImg);
              imageIdArray.splice(i, 0, id);
              vm.$set(vm.$store.instructionImages, instructionId, imageArray);
              vm.$set(
                vm.$store.instructionImagesId,
                instructionId,
                imageIdArray
              );
              resolve();
            },
            (r) => {
              var obj = {
                type: "image",
                data: ".jpeg",
                id: id,
              };

              vm.$store.instructionAttachments = vm.$store
                .instructionAttachments
                ? vm.$store.instructionAttachments
                : {};
              var instAttachments = vm.$store.instructionAttachments[
                instructionId
              ]
                ? vm.$store.instructionAttachments[instructionId]
                : [];
              instAttachments.push(obj);
              vm.$set(
                vm.$store.instructionAttachments,
                instructionId,
                instAttachments
              );

              resolve();
            }
          );
      });
    },
    getVideoAttachment(id, i, instructionId) {
      var vm = this;
      return new Promise((resolve, reject) => {
        this.$http
          .get("dialogs/" + instructionId + "/attachments/" + id, {
            responseType: "arraybuffer",
          })
          .then(
            (response) => {
              let video = btoa(
                new Uint8Array(response.data).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              );
              var instVid = `data:${response.headers[
                "content-type"
              ].toLowerCase()};base64,${video}`;
              var videoArray = vm.$store.instructionVideos[instructionId]
                ? vm.$store.instructionVideos[instructionId]
                : [];
              var videoIdArray = vm.$store.instructionVideosId[instructionId]
                ? vm.$store.instructionVideosId[instructionId]
                : [];

              var videoPresent = true;
              if (videoIdArray.length == 0) {
                videoPresent = false;
              } else {
                if (
                  vm.$store.instructionVideosId[instructionId].indexOf(id) == -1
                ) {
                  videoPresent = false;
                }
              }

              var obj = {
                type: "video",
                data: instVid,
                id: id,
              };

              vm.$store.instructionAttachments = vm.$store
                .instructionAttachments
                ? vm.$store.instructionAttachments
                : {};
              var instAttachments = vm.$store.instructionAttachments[
                instructionId
              ]
                ? vm.$store.instructionAttachments[instructionId]
                : [];
              instAttachments.push(obj);
              vm.$set(
                vm.$store.instructionAttachments,
                instructionId,
                instAttachments
              );

              if (!videoPresent) {
                videoArray.splice(videoArray.length, 0, instVid);
                videoIdArray.splice(videoIdArray.length, 0, id);
                vm.$set(vm.$store.instructionVideos, instructionId, videoArray);
                vm.$set(
                  vm.$store.instructionVideosId,
                  instructionId,
                  videoIdArray
                );
              }
              resolve();
            },
            (r) => {
              var obj = {
                type: "video",
                data: ".mp4",
                id: id,
              };

              vm.$store.instructionAttachments = vm.$store
                .instructionAttachments
                ? vm.$store.instructionAttachments
                : {};
              var instAttachments = vm.$store.instructionAttachments[
                instructionId
              ]
                ? vm.$store.instructionAttachments[instructionId]
                : [];
              instAttachments.push(obj);
              vm.$set(
                vm.$store.instructionAttachments,
                instructionId,
                instAttachments
              );

              resolve();
            }
          );
      });
    },
    getPhraseByIDParagraph(id) {
      return new Promise((resolve, reject) => {
        if (!id) {
          resolve();
          return;
        }
        this.$http.get("/phrases/" + id).then(
          (response) => {
            this.$store.paragraphPhrases.push(response.data);
            resolve(response.data);
          },
          (response) => {
            reject();
          }
        );
      });
    },
    /**
     * Fetch phrase based on ID
     * @param {number} id ID of pharse to fetch
     */
    getPhraseByID(id) {
      return new Promise((resolve, reject) => {
        if (!id) {
          resolve();
          return;
        }
        const storedPhrase = this.$store.phrases.filter((p) => p.id === id)[0];
        if (storedPhrase) {
          this.phrase = storedPhrase;
          resolve();
        } else if (this.dialog.parent == null) {
          resolve();
        } else
          this.$http.get("/phrases/" + id).then(
            (response) => {
              this.phrase = response.data;
              this.$store.phrases.push(response.data);
              resolve();
            },
            (response) => {
              reject();
            }
          );
      });
    },
    /**
     * Append a new dialog with the this dialog as parent
     * @param {string} type The type of the new dialog
     */
    addDialog(type) {
      this.open = true;
      const tempID = Math.random().toString(36).substr(2, 9);
      var new_object = {
        id: tempID,
        new: true,
        editor: this.$store.userID,
        creator: this.$store.userID,
        phrase: null,
        tags: [],
        type: type,
      };
      new_object.parent = [];
      if (this.dialog.tags != null && this.dialog.parent == null) {
        this.dialog.tags.forEach((element) => {
          if (element.includes("start_")) {
            new_object.parent[0] = element;
          }
        });
      } else {
        this.$parent.dialogChild.forEach((element) => {
          if (element.id == this.dialog.id) {
            element.parent.forEach((r) => {
              if (r.includes("start_")) {
                new_object.parent[0] = r;
              }
            });
          }
        });
      }
      new_object.parent.push(this.dialog.id);
      this.dialogChild.push(new_object);
    },
    /**
     * Toggle editing state
     */
    edit() {
      if (!this.$store.dialogTreeSearch) {
        this.rootPath = this.getPathToNode();
      }
      this.editing = !this.editing;
      if (this.editing) {

        this.editingDialog = Object.assign({}, this.dialog);

        this.editingDialog.destination_dialogs = this.rootPath;

        this.editingPhraseText = this.primaryEditingTranslation;
        this.editingDialog.tags =
          this.editingDialog.tags == undefined ? [] : this.editingDialog.tags;
        if (this.editingDialog.tags.length != 0) {
          this.editingDialog.tags.forEach((element) => {
            if (Object.values(this.inputTypes).includes(element)) {
              this.selected = element;
            }
          });
          if(this.editingDialog.tags.includes("paragraph")) {
            this.editingParagraph = true;
          }
          if(this.editingDialog.tags.includes("heading")) {
            this.headingEnabled = true;
          }
        }
        this.editingDialog.editor = this.$store.userID;
      } else {
        this.editingParagraph = false;
      }
    },
    editTag() {
      if (
        this.primaryTranslation != "Phrase has no translation for this language"
      ) {
        this.tagEdit = true;
        this.showChips = true;
        this.categoryTagEdit = false;
        this.arrTag = [];
        this.$http
          .get(
            "/search/tag?lid=" +
              this.$store.preferredLanguage +
              "&did=" +
              this.dialog.id
          )
          .then((response) => {
            response.data.tags.forEach((element) => {
              this.arrTag.push(element);
            });
            if (this.arrTag[0] == "" && this.arrTag.length <= 1) {
              this.arrTag = [];
            }
          })
          .catch(() => this.toast("request Failed"));
      } else {
        M.toast({
          html:
            "Tag cannot be added as the dialog doesn't exist for particular language",
        });
      }
    },
    editCategoryTag() {
      this.tagEdit = false;
      this.categoryTagEdit = true;
      this.showChips = true;
      this.searchCategoryTag = "";
      if(this.dialog.tags != null){
        this.dialog.tags.forEach((element) => {
        this.categoryArrTagList.push(element);
        this.categoryArrTagList = [...new Set(this.categoryArrTagList)]
        this.showSavedTag = true;
        });
      }
    },
    undoTag() {
      this.tagEdit = false;
    },
    undoCategoryTag() {
      this.categoryTagEdit = false;
    },
    addTag() {
      this.showChips = true;
      var tagArray = this.arrTag.join(" ");
      var tagObj = {
        dialog: this.dialog.id,
        language: this.$store.preferredLanguage,
        tag: tagArray,
      };
      this.$http
        .put("/search/tag", tagObj)
        .then((response) => {
          this.tagEdit = false;
        })
        .catch(() => this.toast("request Failed"));
    },
    addCategoryTag() {
      if (this.searchCategoryTag != "") {
        var tag = this.searchCategoryTag;      
        var id = this.dialog.id;

        if(!this.categoryArrTagList.includes(this.searchCategoryTag)){
          this.$http
          .post("dialogs/addCategoryTag?id="+ id +"&tag="+ tag)
          .then((response) => {
            M.toast({
            html: "Category Tag Saved",
            });
            this.showSavedTag = true;
            this.categoryArrTagList.push(tag);
            this.categoryArrTagList = [...new Set(this.categoryArrTagList)]
            this.dialog.tags = this.dialog.tags ? this.dialog.tags : [];
            this.dialog.tags.push(tag);
            this.searchCategoryTag = "";
            this.categoryTagEdit = false;
          })
          .catch(() => this.toast("request Failed"));
        }
        else{
          M.toast({
            html: "duplicate value Cannot be taken",
          });
          this.searchCategoryTag = "";
        }
      }
      else{
        M.toast({
          html: "empty value Cannot be taken",
        });
      }
    },
    tagSearch(event) {
      this.searchArr = [];
      var tagSearch = this.searchTag;
      this.$http
        .get(
          "/search/tagSearch?stag=" +
            tagSearch +
            "&lid=" +
            this.$store.preferredLanguage
        )
        .then((response) => {
          response.data.tags.forEach((element) => {
            this.searchArr.push(element);
          });
        })
        .catch(() => this.toast("request Failed"));
    },
    categoryTagSearch(event) {
      this.searchArr = [];
      var tagSearch = this.searchCategoryTag;
      this.$http
        .get(
          "/search/tagSearch?stag=" +
            tagSearch +
            "&lid=" +
            this.$store.preferredLanguage
        )
        .then((response) => {
          response.data.tags.forEach((element) => {
            this.searchArr.push(element);
          });
        })
        .catch(() => this.toast("request Failed"));
    },
    selectSuggestion(suggestion) {
      this.searchTag = suggestion;
    },
    inputTag(event) {
      if (this.searchTag != "") {
        var tag = this.searchTag;
        this.arrTag.push(tag);
        this.searchTag = "";
        this.searchArr = [];
      } else {
        M.toast({
          html: "empty value Cannot be taken",
        });
      }
    },
    inputCategoryTag(event) {
      this.addCategoryTag();
      this.searchCategoryTag = "";
      this.searchArr = [];
    },
    deleteTag(ind) {
      this.arrTag.splice(ind, 1);
    },
    deleteCategoryTagItem(ind) {
      var id = this.dialog.id;
      this.$http
        .post("dialogs/removeCategoryTag?id="+ id +"&tag="+ this.categoryArrTagList[ind])
        .then((response) => {
          this.categoryArrTagList.splice(ind, 1);
          this.dialog.tags.splice(ind, 1);
          if(this.categoryArrTagList.length == 0)
          {
          this.showSavedTag = false;
          }
        })
        .catch(() => this.toast("request Failed"));
    },
    deletePhrase(phrase, index) {
      this.dialog.tags.forEach((element, index) => {
        if (element.includes("phrase_")) {
          var phraseId = element.split("_");
          var id = phraseId[phraseId.indexOf("phrase") + 1];
          if (phrase.id == id) {
            this.dialog.tags.splice(index, 1);
          }
        }
      });
      this.editingDialog = Object.assign({}, this.dialog);
      this.editingDialog.destination_dialogs = [];
      this.$parent.$emit("update:dialog", this.editingDialog);
      this.toast("dialog has been deleted");
    },
    editParagraph(phrase, index) {
      var displayBox =
        phrase.id + "_" + index + this.$parent.dialog.id + "_" + "span";
      var editbox =
        phrase.id + "_" + index + this.$parent.dialog.id + "_" + "editbox";
      document.getElementById(displayBox).style.display = "none";
      document.getElementById(editbox).style.display = "flex";

      this.editingPhraseText=this.primaryPraragraphTranslation(phrase);
    },
    undoEditParagraph(phrase, index) {
      var displayBox =
        phrase.id + "_" + index + this.$parent.dialog.id + "_" + "span";
      var editbox =
        phrase.id + "_" + index + this.$parent.dialog.id + "_" + "editbox";
      document.getElementById(displayBox).style.display = "flex";
      document.getElementById(editbox).style.display = "none";
    },
    savePhrase(phrase, index) {
      var phraseValue = phrase.id + "_" + index + "textarea";
      var inputValue = this.$refs[phraseValue];
      var input = inputValue[0].value;

      this.updatePhrase(input, this.$store.preferredLanguage, phrase);

      this.loadingDialogs = false;
      this.undoEditParagraph(phrase, index);
    },
    updatePhrase(translationText, translationLanguage, phrase) {
      return new Promise((resolve, reject) => {
        phrase.translations.forEach((element) => {
          if (element.language == translationLanguage) {
            element.text = translationText;
          } else {
            var obj = {
              text: translationText,
              language: translationLanguage,
            };
            phrase.translations.push(obj);
          }
        });
        this.$store
          .putPhrase(phrase)
          .then((response) => {
            resolve(response);
          })
          .catch(() => reject(Error("Could not add phrase")));
      });
    },
    async saveInstruction() {
      this.$store.paragraphPhrases = [];
      this.instructionParagraphs = document
        .getElementById("paragraph")
        .value.replace(/\n$/gm, "")
        .split(/\n/);
      if (this.instructionParagraphs.length > 1) {
        if (
          this.dialog.tags != undefined &&
          this.dialog.tags.includes("paragraph")
        ) {
          this.editingPhraseText = this.instructionParagraphs[0];
          this.instructionParagraphs.splice(0, 1);

          for (var i = 0; i < this.instructionParagraphs.length; i++) {
            var editingPhraseText = this.instructionParagraphs[i];
            var id = "";
            id = await this.createNewPhrase(
              editingPhraseText,
              this.$store.preferredLanguage
            );

            this.paragraphPhraseIds.push(id);
          }
          this.editingDialog.tags.push("paragraph");
          this.paragraphPhraseIds.forEach((e) => {
            var index = this.currentPhraseList.length;
            var phraseId = "phrase_" + e + "_index_" + index;
            this.editingDialog.tags.push(phraseId);
          });
        } else {
          this.editingPhraseText = this.instructionParagraphs[0];
          this.instructionParagraphs.splice(0, 1);
          for (var i = 0; i < this.instructionParagraphs.length; i++) {
            var editingPhraseText = this.instructionParagraphs[i];
            var id = "";
            id = await this.createNewPhrase(
              editingPhraseText,
              this.$store.preferredLanguage
            );

            this.paragraphPhraseIds.push(id);
          }
          this.editingDialog.tags.push("paragraph");
          this.paragraphPhraseIds.forEach((e, index) => {
            var phraseId = "phrase_" + e + "_index_" + index;
            this.editingDialog.tags.push(phraseId);
          });
        }
      }
      if (this.headingEnabled && !this.editingDialog.tags.includes("heading")) {
          this.editingDialog.tags.push("heading");
      } else if (!this.headingEnabled && this.editingDialog.tags.includes("heading")) {
          this.editingDialog.tags = this.editingDialog.tags.filter(tag => tag !== 'heading');
      }
      this.save();
    },
    async getParaGraphPhrase(dialog) {
      this.currentPhraseList = [];
      for (var i = 0; i < dialog.tags.length; i++) {
        var tag = dialog.tags[i];
        if (tag.includes("phrase_")) {
          tag = tag.split("_");
          var phraseId = tag[tag.indexOf("phrase") + 1];
          var index = tag[tag.indexOf("index") + 1];
          await this.getPhraseByIDParagraph(phraseId);
          var phrase = this.$store.phrases[phraseId];
          this.$store.paragraphPhrases.forEach((element) => {
            if (element.id == phraseId) {
              this.currentPhraseList.push(element);
            }
          });
        }
      }
      this.loadingDialogs = false;
    },
    primaryPraragraphTranslation(phrase) {
      if (phrase.translations)
        var foundTranslation = phrase.translations.filter(
          (t) => t.language === this.$store.preferredLanguage
        )[0];
      if (foundTranslation) return foundTranslation.text;
      return foundTranslation
        ? foundTranslation.text
        : "Phrase has no translation for this language";
    },
    /**
     * Call for saving changes to current dialog
     */
    save() {
      if (this.editingPhraseText.length < 1) {
        this.toast("You can't add an empty phrase");
        return;
      }
      var existingPhrase = null;
      if(this.suggestedPhraseID && this.currentSearchResult[this.suggestedPhraseID]){
        existingPhrase = this.currentSearchResult[this.suggestedPhraseID];
        this.suggestedPhraseID = "";
      }
      if (existingPhrase == null) {
        var existingPhrases = this.$store.phrases.filter((p) => {
          var found = false;
          for (let i = 0; i < p.translations.length; i++) {
            if (p.translations[i].text == this.editingPhraseText) {
              found = true;
              break;
            }
          }
          return found;
        });
        var index = null;
        var length = -1;
        existingPhrases.forEach((p, i) => {
          if (p.translations && p.translations.length > length) {
            length = p.translations.length;
            index = i;
          }
        });
        if (index != null) {
          existingPhrase = existingPhrases[index];
        }
      }
      this.editingDialog.isGlobal = this.globally;
      if (existingPhrase) {
        this.editingDialog.phrase = existingPhrase.id;
        this.$parent.$emit("update:dialog", this.editingDialog);
      } else {
        this.loadingPhrase = true;
        this.createNewPhrase(
          this.editingPhraseText,
          this.$store.preferredLanguage
        )
          .then((id) => {
            this.editingDialog.phrase = id;

            this.$parent.$emit("update:dialog", this.editingDialog);
            this.loadingPhrase = false;
          })
          .catch(() => this.toast("Could not add new phrase"));
      }
      this.editingParagraph = false;
      this.editing = false;
    },
    /**
     * Call for saving changes to current dialog
     */
    removeDialog(dialog) {
      if (!dialog.new)
        this.$store
          .deleteDialog(dialog.id)
          .then(() => {
            this.$parent.$emit("delete:dialog", this.dialog);
            this.editing = false;
          })
          .catch(() => this.toast("Could not delete dialog"));
      else this.$parent.$emit("delete:dialog", this.dialog);
    },
    sendDialogOrder(order) {
      return new Promise((resolve, reject) => {
        this.$http.put("/dialogs/" + this.dialog.id + "/order", order).then(
          (response) => {
            resolve(response);
          },
          (response) => {
            reject(response);
          }
        );
      });
    },
    /**
     * Handle incomming dialog update (add or update dialog)
     */
    handleDialogUpdate(dialog) {
      this.saveReminder();
      var globalChange = dialog.isGlobal;
      var order = [];
      dialog["root_dialog"] = this.getRootNodeId();
      
      var rootNode = this.rootDialog;

      if(!dialog.parent.includes("start_" + rootNode.phrase)){
        dialog.parent.push("start_" + rootNode.phrase)
      } 

      if (dialog.new) {
        this.loadingDialogs = true;
        delete dialog.new;
        if (!dialog.isGlobal) {

          if (dialog.destination_dialogs.includes(dialog.id)) {
            var index = dialog.destination_dialogs.indexOf(dialog.id);
            dialog.destination_dialogs.splice(index, 1);
          }
          dialog.is_locally = false;
          delete dialog.isGlobal;

          this.$store.postDialog(dialog).then((response) => {
            this.$set(
              this.$store.dialogParent,
              response.dialog_id,
              this.dialog.id
            );
            this.$set(this.$store.dialogRef, response.dialog_id, this);
            this.dialogChild.splice(this.dialogChild.length - 1, 1);
            dialog.id = response.dialog_id;
            dialog.created = new Date().toISOString();
            this.$store.lastUpdateId = response.dialog_id;
            this.refreshDialogs(
              response.dialog_parent_old,
              response.dialog_parent_new
            );
            this.loadingDialogs = false;
          });
        } else {
          if (dialog.destination_dialogs.includes(dialog.id)) {
            var index = dialog.destination_dialogs.indexOf(dialog.id);
            dialog.destination_dialogs.splice(index, 1);
          }
          dialog.is_locally = true;
          delete dialog.isGlobal;

          this.$store
            .postDialogLocally(dialog)
            .then((response) => {
              this.$set(
                this.$store.dialogParent,
                response.dialog_id,
                this.dialog.id
              );
              this.$set(this.$store.dialogRef, response.dialog_id, this);
              this.dialogChild.splice(this.dialogChild.length - 1, 1);

              dialog.id = response.dialog_id;
              dialog.created = new Date().toISOString();
              this.$store.lastUpdateId = response.dialog_id;
              this.refreshDialogs(
                response.dialog_parent_old,
                response.dialog_parent_new
              );
              this.loadingDialogs = false;
            })
            .catch(() => this.toast("Could not add dialog"));
        }
      } else {
        this.loadingDialogs = true;
        if (!dialog.isGlobal) {
          if (dialog.destination_dialogs.includes(dialog.id)) {
            var index = dialog.destination_dialogs.indexOf(dialog.id);
            dialog.destination_dialogs.splice(index, 1);
          }
          dialog.is_locally = false;
          delete dialog.isGlobal;
          this.$store.putDialog(dialog).then((response) => {
            this.loadingDialogs = true;
            this.dialogChild = [];
            this.updateParent = false;
            this.getNextDialog(this.dialog.id);

            this.$set(this.$store.dialogRef, dialog.id, this);
            this.$set(this.$store.dialogParent, dialog.id, this.dialog.id);
            this.loadingDialogs = false;
          });
        } else {
          if (dialog.destination_dialogs.includes(dialog.id)) {
            var index = dialog.destination_dialogs.indexOf(dialog.id);
            dialog.destination_dialogs.splice(index, 1);
          }
          dialog.is_locally = true;
          delete dialog.isGlobal;

          dialog.parent.forEach((element) => {
            if (element.includes("start") || element.includes(this.dialog.id)) {
            } else {
              var index = dialog.parent.indexOf(element);
              dialog.parent.splice(index, 1);
            }
          });

          this.$store.putDialogLocally(dialog).then((response) => {
            this.loadingDialogs = true;
            this.dialogChild = [];
            this.updateParent = false;
            this.$store.lastUpdateId = response.dialog_id;
            this.refreshDialogs(
              response.dialog_parent_old,
              response.dialog_parent_new
            );
            this.loadingDialogs = false;

            this.$set(this.$store.dialogRef, dialog.id, this);
            this.$set(this.$store.dialogParent, dialog.id, this.dialog.id);
          });
        }
      }
    },
    /**
     * Handle incomming dialog update (add or update dialog)
     */
    handleDialogDelete(dialog) {
      var index = 0;
      if (dialog.new) {
        this.dialogChild.forEach((element) => {
          index += 1;
          if (dialog.id == element.id) {
            this.dialogChild.splice(index - 1, 1);
          }
        });
      } else {
        var parent = this.dialog;
        this.loadingDialogs = true;
        this.$http
          .delete("/dialogs/" + dialog.id + "/parent/" + this.dialog.id)
          .then((response) => {
            this.saveReminder();
            this.toast("Dialog deleted");
            this.dialogChild = [];
            this.updateParent = false;
            if(this.dialog.tags && this.dialog.tags.includes("start")){
              this.updateDialogOrder(this.dialog.id)
            }
            this.getNextDialog(this.dialog.id);
          })
          .catch(() => this.toast("Could not delete dialog"));

        this.loadingDialogs = false;
      }
    },
    handleRootDelete() {
      this.$store.deleteRoot = true;
      this.$store.currentDialog = this.dialog;
    },
    /**
     * Prepare a phrase for posting and if success add it to the store
     * @param {string} translationText Text of translation
     * @param {string} translationLanguage Language of translation
     */
    createNewPhrase(translationText, translationLanguage) {
      return new Promise((resolve, reject) => {
        var phrase = {
          translations: [
            {
              text: translationText,
              language: translationLanguage,
            },
          ],
        };
        this.$store
          .postPhrase(phrase)
          .then((id) => {
            phrase.id = id;
            resolve(id);
          })
          .catch(() => reject(Error("Could not add phrase")));
      });
    },
    /**
     * Retireves the next dialogs
     */
    getNext() {
      return new Promise((resolve, reject) => {
        var a = this.dialog.next.map((id) => {
          return this.getDialogByID(id);
        });
        Promise.all(a).then(() => resolve());
      });
    },
    toast(text) {
      M.toast({
        html: text,
      });
    },
    /**
     * Update the Search State(remove or add search_off from tag) of the dialog
     */
    saveSearchState(event){
      if(this.searchable == true && event.target.checked == true){
        this.$store.postDialogSearchState(this.dialog.id)
          .then((response) => {
              if(response.status == true){
                if (this.dialog.tags) {
                  if (this.dialog.tags.includes("search_off")) {
                    this.dialog.tags.forEach((element,index) => {
                      if (element == "search_off") {
                            this.dialog.tags.splice(index,1)
                      }
                    });
                  }
                }
              }
              })
              .catch(() => this.toast("Could not update dialog search state: "+response.error_msg));
      }
      if(this.searchable == false && event.target.checked == false){
        this.$store.deleteDialogSearchState(this.dialog.id)
          .then((response) => {
            if(response.status == true){
              if (this.dialog.tags) {
                if (!this.dialog.tags.includes("search_off")) {
                  this.dialog.tags.push("search_off")
                }
              }
              else{
                this.dialog.tags = []
                this.dialog.tags.push("search_off")
              }
            }
            })
            .catch(() => this.toast("Could not update dialog search state: "+response.error_msg));
      }
    },
    /**
     * show the pop-up Instance update view
     */
    instanceSetView(){
      this.$store.showDialogInstanceView = true
      this.$store.currentDialogIdForInstanceView = this.dialog.id;
    },
    /**
     * get list of instances based on tag
     */
    getAllInstance(tag) {
      this.allInstances = []
      return new Promise((resolve, reject) => {
        this.$http.get("/dialogs?tag=" + tag).then((response) => {
            response.data.forEach((element) => {
              this.allInstances.push(element.phrase)
            });
          resolve();
          },
          (response) => {
            reject(response);
          });
        });
    },
    /**
     * Get list of visible instance for a dialog on loading the instance list bar
     */
    getVisibleInstanceList(){
      let hiddenInstances =[]
      let currInstance =null
      currInstance = this.getRootName()
      this.getAllInstance("start").then(() =>{
      if (this.dialog.tags != null) {
        this.dialog.tags.forEach((element) => {
          if (element.includes("search_off_")) {
            element = element.replace("search_off_","")
            if(this.allInstances.includes(element))
              hiddenInstances.push(element)
          }
        });
      }
      if(hiddenInstances.length == 0){
        this.visibleInstanceList = []
        this.visibleInstanceList.push("All Instances")
      }
      if(hiddenInstances.length >0){
        this.visibleInstanceList = this.allInstances.filter(x => !hiddenInstances.includes(x))
        if(this.visibleInstanceList.length == 1 && this.visibleInstanceList[0] == currInstance){
          this.visibleInstanceList = []
          this.visibleInstanceList.push("This Instance")
        }
      }
    }).catch(() => this.toast("Could not get instance list"))
    },    
  },
  /**
   * Intitialize the component
   */
  created() {
    this.$on("update:dialog", (d) => this.handleDialogUpdate(d));
    this.$on("delete:dialog", (d) => this.handleDialogDelete(d));
    if (this.isStart) this.open = true;
    if (this.dialog.new) this.edit();
    this.getPhraseByID(this.dialog.phrase)
      .then(() => (this.loadingPhrase = false))
      .catch(() => (this.loadingPhrase = false));
    if (this.parentOpen) {
      if (this.dialog.next)
        this.getNext()
          .then(() => {
            this.initialized = true;
          })
          .catch(() => {
            this.toast("Could not fetch the next set of dialogs");
          });
      else {
        this.initialized = true;
      }
    }
    if (this.dialog.tags != undefined) {
      this.currentPhraseList = [];
      if (this.dialog.tags.includes("paragraph")) {
        this.$store.paragraphPhrases = [];
        this.getParaGraphPhrase(this.dialog);
      } else {
        this.loadingDialogs = false;
      }
    } else {
      this.loadingDialogs = false;
    }
  },
  /**
   * Handle Materialize components on graphical update
   */
  updated() {
    var autoCompletes = this.$el.querySelectorAll(".autocomplete");
    if (autoCompletes) {
      M.Autocomplete.init(autoCompletes, {
        data: this.$store.autocompletePhrases,
        onAutocomplete: (val) => {
          this.editingPhraseText = val;
        },
        limit: 10,
      });
    }
    var tooltips = document.querySelectorAll(".tooltipped");
    if (tooltips) M.Tooltip.init(tooltips, {});
    var elems = document.querySelectorAll(".dropdown-trigg");
    var instances = M.Dropdown.init(elems, {});
    this.$nextTick(function () {
      var elems = document.querySelectorAll(".chips");
      var instances = M.Chips.init(elems, {});
    });
  },
  computed: {
    /**
     * Get translation based on current preferred language
     */
    secondaryTranslation() {
      if (this.isStart) return "";

      if (this.secondaryLanguage === "")
        return "No secondary language is selected";

      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          (t) => t.language === this.secondaryLanguage
        )[0];
      if (foundTranslation) return foundTranslation.text;
      return foundTranslation
        ? foundTranslation.text
        : "Phrase has no translation for the secondary language";
    },
    /**
     * Get translation based on current preferred language
     */
    primaryTranslation() {
      if (this.isStart) return this.dialog.phrase;
      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          (t) => t.language === this.$store.preferredLanguage
        )[0];
      if (foundTranslation) return foundTranslation.text;
      return foundTranslation
        ? foundTranslation.text
        : "Phrase has no translation for this language";
    },

    getStartNodeName(){
      var startNodes = ""
      this.dialog.parent.forEach((p) => {
        if(p.includes("start_")){
            startNodes = startNodes.length == 0 ? p.split("start_")[1] : startNodes + ", " + p.split("start_")[1];
        }
      });
      return startNodes
    },

    /**
     * Get translation based on current preferred language (if none found => '')
     */
    primaryEditingTranslation() {
      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          (t) => t.language === this.$store.preferredLanguage
        )[0];
      return foundTranslation ? foundTranslation.text : "";
    },
    /**
     * Get icon based on dialog's type
     */
    icon() {
      const types = {
        answer: "chat",
        instruction: "feedback",
        question: "help",
        category: "folder",
        start: "view_list",
        default: "error",
      };
      return (
        types[this.dialog.type] || types[this.isStart ? "start" : "default"]
      );
    },
    /**
     * Returns last editor of dialog
     */
    editor() {
      const modifier = this.$store.users.filter(
        (u) => u.id === this.dialog.editor
      )[0];
      return modifier ? modifier.username : "";
    },
    creationInfo() {
      const creator = this.$store.users.filter(
        (u) => u.id === this.dialog.creator
      )[0];
      return creator && this.dialog.created
        ? "Created by " +
            creator.username +
            " ( " +
            this.dialog.created.split("T")[0] +
            " " +
            this.dialog.created.split("T")[1].slice(0, 5) +
            " )"
        : "";
    },
    /**
     * Get empty state of nextDialogs
     */
    empty() {
      for (var key in this.nextDialogs) {
        if (this.nextDialogs.hasOwnProperty(key)) return false;
      }
      return true;
    },
    /**
     * Returns if dialog is start-dialog
     */
    isStart() {
      return this.dialog.tags && this.dialog.tags.indexOf("start") > -1;
    },
    /**
     * Returns if the dialog is loading
     */
    loading() {
      return this.loadingPhrase || this.loadingDialogs;
    },
  },
};
</script>
